import { Star } from "lucide-react";
import { fileUrl } from "@/lib/api";

export const ReviewCard = ({ r }) => (
  <div className={`bg-[#12141a] border rounded-2xl p-6 ${r.featured ? "border-[#ff6a13]/60 ring-1 ring-[#ff6a13]/40" : "border-zinc-800"}`} data-testid="review-card">
    <div className="flex items-center justify-between">
      <div className="flex gap-0.5 text-[#ffd600]">
        {[1, 2, 3, 4, 5].map((n) => <Star key={n} size={16} className={n <= r.rating ? "fill-[#ffd600]" : "text-zinc-700"} />)}
      </div>
      {r.featured && <span className="text-[10px] font-mono-p uppercase tracking-wider text-[#ff6a13] border border-[#ff6a13]/40 rounded-full px-2 py-0.5" data-testid="review-featured-badge">★ Featured</span>}
    </div>
    {r.photo_url && (
      <div className="mt-3 checker rounded-xl overflow-hidden flex items-center justify-center">
        <img src={fileUrl(r.photo_url)} alt="Customer print" className="max-h-56 w-full object-contain" data-testid="review-photo" />
      </div>
    )}
    {r.text && <p className="text-zinc-300 mt-3 leading-relaxed">"{r.text}"</p>}
    <p className="text-sm text-white font-semibold mt-4">— {r.customer_name}</p>
    {r.owner_reply && (
      <div className="mt-4 border-l-2 border-[#ff6a13] pl-3" data-testid="review-owner-reply">
        <p className="text-[10px] uppercase tracking-wider text-[#ff6a13] font-mono-p">Owner response</p>
        <p className="text-sm text-zinc-400 mt-1">{r.owner_reply}</p>
      </div>
    )}
  </div>
);

export const StarSummary = ({ reviews }) => {
  if (!reviews.length) return null;
  const avg = reviews.reduce((s, r) => s + (r.rating || 0), 0) / reviews.length;
  return (
    <div className="flex items-center gap-3 mt-4" data-testid="review-summary">
      <span className="font-display text-4xl font-black text-white">{avg.toFixed(1)}</span>
      <div>
        <div className="flex gap-0.5 text-[#ffd600]">
          {[1, 2, 3, 4, 5].map((n) => <Star key={n} size={18} className={n <= Math.round(avg) ? "fill-[#ffd600]" : "text-zinc-700"} />)}
        </div>
        <p className="text-xs text-zinc-400 mt-0.5" data-testid="review-summary-count">{reviews.length} review{reviews.length === 1 ? "" : "s"}</p>
      </div>
    </div>
  );
};
